import { render, staticRenderFns } from "./ItemClassRange.vue?vue&type=template&id=687d5c36"
import script from "./ItemClassRange.vue?vue&type=script&lang=js"
export * from "./ItemClassRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports